module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-1-147cfc2991dd34d2148a8f6b110b2c13.webp";